import Marquee from "react-fast-marquee";
import { BRAND_CATEGORIES, ALL_BRANDS } from "@/data/site";

export default function Brands() {
  return (
    <section
      id="products"
      data-testid="brands-section"
      className="section-pad relative bg-[#0A1128]/40 border-y border-white/5"
    >
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-6">
            — Products & Brand Partners
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.1]">
            Built only with{" "}
            <span className="italic text-[#FFC857]">Tier 1 components.</span>
          </h2>
          <p className="mt-6 text-[#A0ABC0] text-base md:text-lg font-light">
            From Bloomberg-rated modules to industrial-grade ACDB/DCDB —
            every component is sourced from globally trusted manufacturers.
          </p>
        </div>
      </div>

      <div className="mt-16 overflow-hidden">
        <Marquee gradient gradientColor="#050B14" speed={42} pauseOnHover>
          {[...ALL_BRANDS, ...ALL_BRANDS].map((b, i) => (
            <div
              data-testid={`brand-logo-${i}`}
              key={`${b.name}-${i}`}
              className="mx-10 flex items-center justify-center h-20"
              title={b.name}
            >
              <img
                src={b.logo}
                alt={b.name}
                className="brand-logo h-12 max-w-[160px] object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.parentElement.innerHTML = `<span class='font-serif text-2xl text-white/60'>${b.name}</span>`;
                }}
              />
            </div>
          ))}
        </Marquee>
      </div>

      <div className="container-x mt-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {BRAND_CATEGORIES.map((cat, i) => (
            <div
              data-testid={`brand-cat-${i}`}
              key={cat.title}
              className="glass rounded-sm p-7"
            >
              <div className="text-xs uppercase tracking-[0.25em] text-[#FFC857]">
                Category {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-serif text-2xl text-white mt-3">
                {cat.title}
              </h3>
              <ul className="mt-5 space-y-2.5">
                {cat.brands.map((b) => (
                  <li
                    key={b.name}
                    className="flex items-center gap-3 text-sm text-[#A0ABC0]"
                  >
                    <span className="h-1 w-1 rounded-full bg-[#FFC857]" />
                    {b.name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
